import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Seo from "../components/seo"
import HeaderLayout from "../components/headerLayout"
import StyledTextSectionClean from "../components/textSectionClean"
import Img from "gatsby-image"

const Pilot = () => {
  const data = useStaticQuery(graphql`
    query {
      bilde1: file(relativePath: { eq: "pilot_bilde1.jpg" }) {
        childImageSharp {
          fixed(width: 500, height: 350, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      bilde2: file(relativePath: { eq: "pilot_bilde2.jpg" }) {
        childImageSharp {
          fixed(width: 600, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Seo title="Pilot" />
      <HeaderLayout />
      <StyledTextSectionClean fullWidth id="pilot" header="PILOT">
        <p>
          Testperioden ble organisert gjennom to ulike faser fordelt på totalt 8
          måneder. Første fase besto i å gi skolene tre timers
          introduksjonsopplæring i oppbygging og bruk av læremiddelet. Deretter
          ble det laget individuelle planer for omfang og gjennomføring av
          pilotperioden.
        </p>
        <div className="center-c">
          <Img to="Img" fixed={data.bilde1.childImageSharp.fixed} />
        </div>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>Fase 1 av pilotperiode</h2>
        <p>
          De første læringsmålene som ble testet ut var: gjenkjenne,
          risikovurdere, varsle og B-L-Å metoden. Erfaringene fra første
          testperiode ble både gjennomgått, diskutert og dokumentert før andre
          fase i testperioden ble igangsatt. Basert på innspillene fra første
          testperiode ble lærerveiledningene justert og sendt ut til
          prosjektdeltagerne for gjennomgang, før ny versjon ble publisert.{" "}
        </p>
        <h2>Fase 2 av pilotperiode </h2>
        <p>
          Målet for andre periode var å teste flest mulig læringsmål, og å
          gjennomføre en bredere evaluering.
        </p>
        <p>Delmålene for perioden var: </p>
        <ul>
          <li>
            Flest mulig lærere på skolen testet ut lærerveiledningen og
            læringsressursene
          </li>
          <li>
            Førstehjelp ble testet ut tverrfaglig, for eksempel i naturfag, KRLE
            med flere
          </li>
          <li>Praktisk førstehjelpstrening ble brukt på utflukter og turer </li>
          <li>
            Strukturert evaluering fra både lærer og elever gjennom observasjon
            og dybdeintervjuer{" "}
          </li>
        </ul>
        <p>
          Evalueringene og innspillene fra både første og andre pilotfase ble
          systematisk oppsummert i en egen rapport. Deretter ble det gjennomført
          et felles arbeidsmøte før endringene ble implementert.
        </p>
        <p>Endringene omtales videre under evalueringsdelen. </p>
        <strong>Deltagende skoler var:</strong>
        <ul>
          <li>Døli barneskole, Ullensaker kommune</li>
          <li>Trasop barneskole, Oslo kommune</li>
          <li>Møllergata barneskole, Oslo kommune </li>
          <li>St. Sunniva katedralskole, Oslo </li>
          <li>Grønnåsen ungdomsskole, Tromsø kommune </li>
          <li>Slettaelva barneskole, Tromsø kommune</li>
          <li>Kvaløysletta ungdomsskole, Tromsø kommune</li>
        </ul>
        <div className="center-c">
          <Img to="Img" fixed={data.bilde2.childImageSharp.fixed} />
        </div>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>EVALUERING</h2>
        <p>
          Evalueringen ble utført og dokumentert av Sintef. Hovedmålet for
          evalueringsarbeidet var å etablere kunnskap og innsikt for å
          videreutvikle og forbedre læremiddelet fram til utrulling nasjonalt.
        </p>
        <p>
          Delmålet var å etablere kunnskap om lærerens holdning og erfaring med
          førstehjelp som tema, samt hvordan læremiddelet fungerte i praksis.
        </p>
        <p>
          Evalueringen besto i praksisnære metoder, nærhet og dialog og
          erfaringsutveksling for utvikling mot ny praksis og besto i:
        </p>
        <ul>
          <li>Spørreskjema til alle lærere ved pilotskolene</li>
          <li>Intervjuer med lærere </li>
          <li>Observasjon av opplæring </li>
          <li>Intervju med elever </li>
          <li>Spørreskjema til elever </li>
        </ul>
        <p>
          Resultatene ble dokumentert gjennom to rapporter, med oppsummering av
          funn og forslag til forbedringsområder.
        </p>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>FUNNENE</h2>
        <p>Nedenfor oppsummeres de viktigste funnene fra evalueringen.</p>
        <ul>
          <li>Lærerne er motivert og mestrer å undervise i førstehjelp</li>
          <li>Førstehjelp kan brukes i mange fag</li>
          <li>
            Læremiddelet har forbedringsområder med hensyn til språk, eksempler
            og bruk av ny teknologi
          </li>
          <li>
            Både lærere og elever forstår og klarer å bruke B-L-Å i praksis.
          </li>
          <li>
            Lærerne brukte de fleste av læringsressursene som var tilgjengelig
          </li>
        </ul>
        <strong>SPØRREUNDERSØKELSE</strong>
        <p>
          Hensikten var å få innsikt i kunnskaper om førstehjelp hos lærerne,
          hvilke holdninger lærerne har til førstehjelp og hvilke forventninger
          de har til det kommende læremiddelet. Dette vil gi et godt grunnlag
          for å utforme førstehjelpsundervisningen på de deltakende skolene.
          Totalt 150 lærere besvarte undersøkelsen.
        </p>
        <p>
          Ca. 90% av lærerne svarer at de har deltatt på kurs/opplæring i
          førstehjelp
        </p>
        <ol>
          <li>95% av disse har hatt kurs i HLR</li>
          <li>Ca. 50% har hatt kurs i livredning i vann</li>
          <li>
            30-45% har hatt kurs i førstehjelp knyttet til bevisstløshet,
            blødninger, brann- og bruddskader
          </li>
        </ol>
        <p>
          30% svarer: at de har undervist i førstehjelp for elever i grunnskolen
        </p>
        <ol>
          <li>90% har undervist i HLR</li>
          <li>60% har undervist i livredning i vann og bevisstløshet</li>
          <li>
            30% har undervist i førstehjelp ved alvorlig skade eller brannskade
          </li>
          <li>
            60% har undervist i førstehjelp dette skoleåret (halvparten) eller
            de siste 3 årene
          </li>
          <li>
            Det er primært 8.-10. trinn som har fått undervisning (60%), 40% har
            gitt undervisning for 5.-7. trinn, mens 15% svarer at de har
            undervist på 1.-4. trinn.
          </li>
        </ol>
        <p>
          30% svarer at førstehjelp er et emne i undervisningen på skolen dette
          skoleåret; tilsvarende gruppe svarer at de ikke vet.{" "}
        </p>
        <p>
          95% av lærerne foretrekker å få et ferdig undervisningsopplegg og
          opplæringsmateriell for gjennomføring av førstehjelpsundervisningen.{" "}
        </p>
        <p>
          Lærerne ønsker seg digitale læremidler og ressurser for
          gjennomføringen, primært filmer og bildehistorier, instruksjonsfilmer
          og nettbaserte øvelser. Plakater, quiz og opplegg for rollespill
          trekkes også frem som aktuelle læremidler.{" "}
        </p>
      </StyledTextSectionClean>
    </>
  )
}

export default Pilot
